<template>
  <v-app>
    <v-app-bar app color="#373638" dense dark elevate-on-scroll>
      <v-app-bar-title style="width: 100px" class="d-none d-sm-flex"><a style="color: white" @click="$vuetify.goTo('#multiscan')">MultiScan</a></v-app-bar-title>
      <v-tabs active-class="active" class="ml-n9" align-with-title optional right hide-slider>
        <v-spacer></v-spacer>
        <v-tab @click="$vuetify.goTo('#viz')" >
          Viz
        </v-tab>
        <v-tab @click="$vuetify.goTo('#resources')">
          Data
        </v-tab>
        <v-tab @click="$vuetify.goTo('#resources')">
          Doc
        </v-tab>
        <v-tab @click="$vuetify.goTo('#resources')">
          <v-icon class="mr-sm-1" size="22">mdi-github</v-icon>
          <span class="d-none d-sm-flex">Code</span>
        </v-tab>
      </v-tabs>
    </v-app-bar>
    <v-main>
      <router-view v-slot="{ Component }">
        <transition name="fade">
          <component :is="Component"/>
        </transition>
      </router-view>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({

    showBarTitle: false
  }),

  methods: {
    // onScroll(e) {
    //   console.log(e.target.scrollTop)
    // },
  },


};
</script>
<style>
.active {
  color: rgba(255, 255, 255, 0.6) !important;
}
</style>
